export type RegistrationState = 'unregistered' | 'registering' | 'registered' | 'failed';
export type TransportState = 'connected' | 'disconnected';
export type CallStatus = 'ringing-in' | 'calling' | 'established' | 'held';
export type Direction = 'in' | 'out';

export interface CallInfo {
  status: CallStatus;
  direction: Direction;
  remote: string;
  displayName?: string;
  startedAt: number;
  answeredAt?: number;
  muted: boolean;
  held: boolean;
}

export interface Session {
  loggedIn: boolean;
  durchwahl?: string;
  sipExtension?: string;
}

export interface AppState {
  session: Session;
  registration: RegistrationState;
  transport: TransportState;
  call: CallInfo | null;
  missedCount: number;
  message: string | null;
}

export const initialState: AppState = {
  session: { loggedIn: false },
  registration: 'unregistered',
  transport: 'disconnected',
  call: null,
  missedCount: 0,
  message: null,
};

export interface Store {
  getState(): AppState;
  setState(partial: Partial<AppState>): void;
  subscribe(listener: (s: AppState) => void): () => void;
}

export function createStore(initial: AppState = initialState): Store {
  let state = initial;
  const listeners = new Set<(s: AppState) => void>();
  return {
    getState: () => state,
    setState(partial) {
      state = { ...state, ...partial };
      for (const l of listeners) l(state);
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
